module.exports = __webpack_public_path__ + "static/media/image-thumb-6.03cdc635.jpeg";